import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {catchError, retry} from "rxjs/operators";
import {ConstantsService} from "@app/services/constants/constants.service";
import {environment} from "@env/environment";

@Injectable({
    providedIn: 'root'
})
export class CalendarService {
    private apiURL = environment.apiURL;

    constructor(private http: HttpClient,
                private constantsService: ConstantsService) {
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            return of(result as T);
        };
    }


    getEvents() {
        let params = new HttpParams()
            .set('creator', this.constantsService.creator_id);
        return this.http.get(this.apiURL + '/calendar/getData', {params}).pipe(
            retry(1),
            catchError(this.handleError<any>('getData')));
    }


}
